module.exports = __webpack_public_path__ + "img/safedig_logo_grayscale-01.81d0ca1c.png";